export const educationData = [
    {
        id: 1,
        institution: 'Masai School',
        course: `Full Stack Web Development`,
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        institution: 'Nirmala Convent Hr Sec School',
        course: `CBSE XII (89.8%)`,
        startYear: '',
        endYear: '2019'
    },
   
]